import React, { Fragment, useEffect, useState } from "react";
import Dashboard from "../Common/Components/Dashboard";
import Filters from "./Filter";
import GridWidget from "./GridWidget";
import DashboardOptions from "../Common/Components/DashboardOptions";

const Mdc = () =>{
  
    const positionData = 
    [{ col: 1, colSpan: 6, rowSpan: 6 },
    {col:5,colSpan: 2, rowSpan: 3},
    {col:1,colSpan:6,rowSpan:3}]

    const [params, updateParams] = useState({ assembly: null, description: null, component: null, terms: { country: "all", deviceTypes: [] } });


    const paramHandler = (p) => {
        updateParams(p)
    }


    const sidebarItems = [
        { title: "Filters", item: <Filters id="partwearout-filters" updateParams={paramHandler} />, expanded: true },
        {title: "Dashboard Options", item: < DashboardOptions />, expanded: true }
    ];

    return (
        <Fragment>
            <Dashboard positionData={positionData} sidebarItems={sidebarItems}>
                <GridWidget id="mdc-grid-widget" header="Header cumulative values per device" params={params } />
            </Dashboard>
        </Fragment>
    )
}

export default Mdc;